export default {
    mounted() {
        this.setClickEvents();
    },
    methods: {
        setClickEvents() {
            let smoothLinks = document.querySelectorAll('.smooth-link');

            smoothLinks.forEach(link => {
                link.addEventListener('click', e => {
                    e.preventDefault();
                    let section = document.querySelector(link.hash);
                    window.scroll({top: section.offsetTop, behavior: 'smooth'})
                });
            });

            // Set active class on nav
            window.addEventListener('scroll', () => {
                let fromTop = window.scrollY;

                smoothLinks.forEach(link => {
                    let section = document.querySelector(link.hash);

                    if (
                        section.offsetTop <= fromTop &&
                        section.offsetTop + section.offsetHeight > fromTop
                    ) {
                        link.classList.add('policy__nav-link--active');
                    } else {
                        link.classList.remove('policy__nav-link--active');
                    }
                });
            });
        },
    },
};
